import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import { FC } from 'react';
import styles from "../../assets/styles/appointments.module.css"
import NoDataFound from '../common/NoDataFound';

interface Props {
    labTests: LabTestRequestTypes[],
}
const LabTestRequestTable: FC<Props> = ({ labTests }) => {
    return (
        <TableContainer component={Paper} className='TableContainer'>
            <Table sx={{ minWidth: 650 }} aria-label="health test requests">
                <TableHead className='custumTableHead'>
                    <TableRow className={styles.completeTableRow}>
                        <TableCell>Employee Name</TableCell>
                        <TableCell>Booking ID</TableCell>
                        <TableCell>Lab Name</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Booking Date & Time</TableCell>
                        <TableCell>Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        labTests?.length > 0 ?
                            labTests.map((item) => (
                                <TableRow
                                    key={item?.labOrderId}
                                    className='custumTableRow'
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">{item?.patientName}</TableCell>
                                    <TableCell>{item?.uniqueBookingId || '-'}</TableCell>
                                    <TableCell>{item?.labName || '-'}</TableCell>
                                    <TableCell>{item?.labCityName || '-'}</TableCell>
                                    <TableCell>{item?.types || '-'}</TableCell>
                                    <TableCell>
                                        {item?.bookingDate ? moment(item?.bookingDate).format('DD MMM YYYY') : '-'}
                                        {item?.bookingTime ? `, ${item?.bookingTime}` : ''}
                                    </TableCell>
                                    <TableCell>{item?.orderStatus}</TableCell>
                                </TableRow>
                            ))
                            :
                            <TableRow
                                className='custumTableRow'
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row" colSpan={7}>
                                    <NoDataFound />
                                </TableCell>
                            </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default LabTestRequestTable;
